import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { FaHome, FaExternalLinkAlt, FaComments } from "react-icons/fa";
import { GrDocumentText } from "react-icons/gr";

const AdminSidebar = () => {
  return (
    // Sidebar
    <ul className="navbar-nav bg-gradient-dark sidebar sidebar-dark accordion" id="accordionSidebar">
      {/* Sidebar - Brand */}
      <Link to={'/hy-admin'} className="sidebar-brand d-flex align-items-center justify-content-center">
        <img alt="HY교육 로고" src="https://contents.sixshop.com/uploadedFiles/151941/default/image_1717761196385.png" />
      </Link>
      <hr className="sidebar-divider my-0" />

      {/* 메인 */}
      <li className="nav-item">
        <NavLink to={"/hy-admin"} className='nav-link' activeclassname="active" end>
          <span className='me-1'><FaHome /></span>
          <span className='align-middle'>메인</span>
        </NavLink>
      </li>
      <hr className="sidebar-divider my-0" />

      {/* 상담신청 관리 */}
      <li className="nav-item">
        <NavLink to={"/hy-admin/survey"} className='nav-link' activeclassname="active">
          <span className='me-1'><GrDocumentText /></span>
          <span className='align-middle'>상담신청 관리</span>
        </NavLink>
      </li>
      <hr className="sidebar-divider my-0" />


      {/* 상담내용 관리 */}
      <li className="nav-item">
        <NavLink to={"/hy-admin/counsel"} className='nav-link' activeclassname="active">
          <span className='me-1'><GrDocumentText /></span>
          <span className='align-middle'>상담내용 관리</span>
        </NavLink>
      </li>
      <hr className="sidebar-divider my-0" />


      {/* 생활기록부 관리 */}
      <li className="nav-item">
        <NavLink to={"/hy-admin/school-record"} className='nav-link' activeclassname="active">
          <span className='me-1'><GrDocumentText /></span>
          <span className='align-middle'>생활기록부 관리</span>
        </NavLink>
      </li>
      <hr className="sidebar-divider my-0" />

      {/* 채팅 관리 */}
      <li className="nav-item">
        <NavLink to={"/hy-admin/chatting"} className='nav-link' activeclassname="active">
          <span className='me-1'><FaComments /></span>
          <span className='align-middle'>채팅</span>
        </NavLink>
      </li>
      <hr className="sidebar-divider my-0" />


      {/* 강의관리 */}
      {/* <li className="nav-item">
            <NavLink to={'/hy-admin/lectures'} className='nav-link' activeclassname="active">
              <span className='me-1'><FaTv /></span>
              <span className='align-middle'>강의관리</span>
            </NavLink>
          </li> 
          <hr className="sidebar-divider my-0" /> */}


      <li className="nav-item">
        <Link to={'/'} className='nav-link' target='_blank' rel="noopener noreferrer">
          <span className='me-1'><FaExternalLinkAlt /></span>
          <span className='align-middle'>홈페이지 이동</span>
        </Link>
      </li>
      <hr className="sidebar-divider my-0" />


    </ul>
    // End of Sidebar
  )
}

export default AdminSidebar